import { z } from 'zod';
/**
 * ECN（工程变更单）：无人工编号，系统生成 id。
 * 由 Excel（ECN20260122B.xls 格式）上传：表头(日期/变更PCBA料号) + 多行「变更前→变更后」。
 * 原始文件存 S3，可下载；通知邮件带此文件附件。
 */
/** 变更前/后的物料快照 */
export const EcnChangeItemSchema = z.object({
    part_no: z.string().max(120).default(''),
    name: z.string().max(300).default(''),
    spec: z.string().max(1000).default(''),
    designator: z.string().max(2000).default(''),
    qty: z.union([z.number(), z.string()]).optional(),
});
/** 一条变更明细：before → after */
export const EcnLineSchema = z.object({
    no: z.number().int().nonnegative(),
    before: EcnChangeItemSchema,
    after: EcnChangeItemSchema,
    remark: z.string().max(500).optional(), // 如「型号变更」
});
/** ECN 主档 */
export const EcnMetaSchema = z.object({
    id: z.string(),
    ecn_date: z.string().max(20), // YYYYMMDD（解析自文件「日期：」）
    change_subject: z.string().max(500).optional(), // 变更项目
    change_summary: z.string().max(500).optional(), // 变更摘要：变更前规格 → 变更后规格（上传时自动生成）
    affected_pcba: z.string().max(200).optional(), // 变更PCBA料号
    line_count: z.number().int().nonnegative().default(0),
    source_file_name: z.string().max(300).optional(),
    source_file_s3_key: z.string().max(500).optional(), // 原始 .xls，可下载/发附件
    created_at: z.number().int().optional(),
    created_by_user_id: z.string().optional(),
});
/** 新建 ECN（Excel 解析 + 原文件已传 S3 后提交） */
export const CreateEcnSchema = z.object({
    ecn_date: z.string().trim().min(1).max(20),
    change_subject: z.string().trim().max(500).optional(),
    affected_pcba: z.string().trim().max(200).optional(),
    source_file_name: z.string().max(300).optional(),
    source_file_s3_key: z.string().max(500).optional(),
    lines: z.array(EcnLineSchema).min(1).max(1000),
    /** 是否发布后给联系人发通知邮件（带附件） */
    notify: z.boolean().default(false),
    notify_subject: z.string().max(200).optional(), // 自定义邮件主题，留空用默认
    notify_body: z.string().max(5000).optional(), // 自定义邮件正文，留空用默认
});
/** 料号时间线一条（前端展示用，内嵌前后内容免二次查询） */
export const PartTimelineEntrySchema = z.object({
    ecn_id: z.string(),
    ecn_date: z.string(),
    role: z.enum(['before', 'after']),
    line_no: z.number().int(),
    before: EcnChangeItemSchema.optional(),
    after: EcnChangeItemSchema.optional(),
    remark: z.string().optional(),
});
//# sourceMappingURL=ecn.js.map